import * as actionTypes from '../constants/financeRequests';

const initialState = {
	allFinReqPending: [],
	isFetchingFinReqPending: false,

	// pendingCount: 0,
	// approvedCount: 0,
	// rejectedCount: 0,

	allFinReqNumbers: [],
	isFetchingFinReqNumbers: false,

	allFinReqApproved: [],
	isFetchingFinReqApproved: false,

	allFinReqRejected: [],
	isFetchingFinReqRejected: false,

	finReqSelectedRow: {},
	isFetchingFinReqSelectedRow: false
};

const initialAction = {
	type: '',
	payload: {},
	message: ''
};
const financeRequests = (state = initialState, action = initialAction) => {
	switch (action.type) {
		case actionTypes.FETCH_FIN_REQ_PENDING_ALL_BEGIN:
			return {
				...state,
				isFetchingFinReqPending: true
			};
		case actionTypes.FETCH_FIN_REQ_PENDING_ALL_FAILURE:
			return {
				...state,
				isFetchingFinReqPending: false
			};
		case actionTypes.FETCH_FIN_REQ_PENDING_ALL_SUCCESS:
			return {
				...state,
				allFinReqPending: action.payload.allFinReqPending,
				isFetchingFinReqPending: false
			};

		case actionTypes.FETCH_FIN_REQ_APPROVED_ALL_BEGIN:
			return {
				...state,
				isFetchingFinReqApproved: true
			};
		case actionTypes.FETCH_FIN_REQ_APPROVED_ALL_FAILURE:
			return {
				...state,
				isFetchingFinReqApproved: false
			};
		case actionTypes.FETCH_FIN_REQ_APPROVED_ALL_SUCCESS:
			return {
				...state,
				allFinReqApproved: action.payload.allFinReqApproved,
				isFetchingFinReqApproved: false
			};

		case actionTypes.FETCH_FIN_REQ_REJECTED_ALL_BEGIN:
			return {
				...state,
				isFetchingFinReqRejected: true
			};
		case actionTypes.FETCH_FIN_REQ_REJECTED_ALL_FAILURE:
			return {
				...state,
				isFetchingFinReqRejected: false
			};
		case actionTypes.FETCH_FIN_REQ_REJECTED_ALL_SUCCESS:
			return {
				...state,
				allFinReqRejected: action.payload.allFinReqRejected,
				isFetchingFinReqRejected: false
			};
		case actionTypes.FETCH_FIN_REQ_APPROVE_BEGIN:
			return {
				...state,
				isFetchingFinReqSelectedRow: true
			};
		case actionTypes.FETCH_FIN_REQ_APPROVE_SUCCESS:
			return {
				...state,
				finReqSelectedRow: action.payload.finReqSelectedRow,
				isFetchingFinReqSelectedRow: false
			};
		case actionTypes.FETCH_FIN_REQ_APPROVE_FAILURE:
			return {
				...state,
				isFetchingFinReqSelectedRow: true
			};

		case actionTypes.FETCH_FIN_REQ_NUMBER_BEGIN:
			return {
				...state,
				isFetchingFinReqNumbers: true
			};
		case actionTypes.FETCH_FIN_REQ_NUMBER_SUCCESS:
			return {
				...state,
				// pendingCount: action.payload.pending,
				// approvedCount: action.payload.approved,
				// rejectedCount: action.payload.rejected,
				allFinReqNumbers: action.payload.allFinReqNumbers,
				isFetchingFinReqNumbers: false
			};
		case actionTypes.FETCH_FIN_REQ_NUMBER_FAILURE:
			return {
				...state,
				isFetchingFinReqNumbers: true
			};
		default:
			return state;
	}
};

export default financeRequests;
